export default {"src":"/_next/static/media/FieldsWhite.d7583c12.svg","height":34,"width":34};